/**
 * Jacquard icon intent registry (ADR-012 §2).
 *
 * Maps semantic intent names (Zone 1 cross-platform contract) to
 * Lucide React component names. iOS maps the same intents to
 * SF Symbol system names via tokens/reference/icons.json.
 */
export const ICON_REGISTRY = {
  close: 'X',
  search: 'Search',
  'chevron-down': 'ChevronDown',
  'chevron-left': 'ChevronLeft',
  'chevron-right': 'ChevronRight',
  'chevron-up': 'ChevronUp',
  calendar: 'Calendar',
  clock: 'Clock',
  'arrow-left': 'ArrowLeft',
  'arrow-right': 'ArrowRight',
  'arrows-right-left': 'ArrowLeftRight',
  menu: 'Menu',
  settings: 'Settings',
  user: 'User',
  info: 'Info',
  warning: 'AlertTriangle',
  success: 'CheckCircle2',
  error: 'XOctagon',
  edit: 'Pencil',
  trash: 'Trash2',
  share: 'Share',
  heart: 'Heart',
  star: 'Star',
  pin: 'Pin',
  check: 'Check',
  plus: 'Plus',
} as const;

export type IconIntent = keyof typeof ICON_REGISTRY;
